// services/produtos/AdicionalService.js
import { fetchData, postData, putData, deleteData } from '../Api';

export const getAdicionais = async () => {
    return fetchData('/Adicional');
};



export const addAdicional = async (adicional) => {
    return postData('/Adicional', adicional);
};

export const updateAdicional = async (adicional) => {
    return putData('/Adicional', adicional);
};

export const deleteAdicional = async (id) => {
    return deleteData('/Adicional', { adicionalId: id });
};
